// Stylesheets
import './assets/scss/site.scss';

import { hover } from './assets/modules/hover';
import { copyUrl } from './assets/modules/copyUrl';
import { externalLink } from './assets/modules/externalLink';
import { fluidEmbed } from './assets/modules/fluidEmbed';
import { popup } from './assets/modules/popup';
import { trigger } from './assets/modules/trigger';
import { initPhotoSwipeFromDOM } from './assets/modules/photoswipe';
import { countdown } from './assets/modules/countdown.js';
import { scrollOpacityFade } from './assets/modules/scrollOpacityFade.js';
import { stickySidebar } from './assets/modules/stickySidebar';
import { filterProgram } from './assets/modules/filterProgram.js';
import { scribble } from './assets/modules/scribble';
import { randomGallery } from './assets/modules/randomGallery.js';
import { accessMap }  from './assets/modules/accessMap';
import Calendar from './assets/modules/calendar';
import { formSelect } from './assets/modules/form.js';
import { search }  from './assets/modules/search';

const init = () => {
  hover();
  copyUrl();
  externalLink();
  fluidEmbed();
  popup();
  trigger();
  initPhotoSwipeFromDOM('.js-pswp-container');
  countdown();
  scrollOpacityFade();
  stickySidebar();
  filterProgram();
  scribble();
  randomGallery();
  accessMap();
  formSelect();
  search();
  document.body.classList.add('is-init');
}

init();